import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { railIconButtonClassName } from "@/layouts/WorkspaceLayout/components/WorkspaceLeftRail/rail/railIconButtonClassName";
import {
  workspacePopoverTooltipArrowClassName,
  workspacePopoverTooltipContentClassName,
} from "@/layouts/WorkspaceLayout/components/workspacePopoverTooltipClassName";
import { cn } from "@/utils";
import { Plus, type LucideIcon } from "lucide-react";

/** Compact header action in a rail section — matches dashboard-comp. */
export function RailGroupActionButton({
  label,
  onClick,
  disabled,
  icon: Icon = Plus,
  ...buttonProps
}: {
  label: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  icon?: LucideIcon;
} & Omit<
  React.ComponentPropsWithoutRef<"button">,
  "type" | "aria-label" | "onClick" | "disabled" | "className" | "children"
>) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={label}
          disabled={disabled}
          onClick={onClick}
          className={cn(
            railIconButtonClassName,
            disabled && "pointer-events-none opacity-50",
          )}
          {...buttonProps}
        >
          <Icon className="size-4" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="bottom"
        sideOffset={4}
        arrowClassName={workspacePopoverTooltipArrowClassName}
        className={cn(
          "px-2.5 py-1.5 text-xs",
          workspacePopoverTooltipContentClassName,
        )}
      >
        {label}
      </TooltipContent>
    </Tooltip>
  );
}
